import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getAgreementListFilterFilters = (state: IRootState) => state.agreementListFilter.filters;
export const getAgreementListFilterCurrentFilter = (state: IRootState) => state.agreementListFilter.current;
export const getAgreementListFilterIsFilterOn = (state: IRootState) => state.agreementListFilter.isFilterOn;
export const getAgreementListFilterCurrentId = (state: IRootState) => state.agreementListFilter.currentId;
export const getAgreementListFilterPlanNum = (state: IRootState) => state.agreementListFilter.planNum;
